module.exports = __webpack_public_path__ + "static/media/bl.ca2e503f.png";